<template>
  <div id="app" >
    <div v-if="!$route.meta.hiddleNav">
    <el-menu
      router
      :default-active="$route.path"
      class="el-menu-demo"
      mode="horizontal"
    
      background-color="#545c64"
      text-color="#fff"
      active-text-color="#ffd04b"
    >
      <el-menu-item index="/">首页</el-menu-item>
      
      <el-menu-item index="/chat">OpenAi聊天</el-menu-item>
     
     

   
    </el-menu>



    </div>

    <router-view />
  </div>
</template>



<script>
export default {
  name: "App",
  data() {
    return {
    
      
    };
  },
  created() {
    //在页面加载时读取sessionStorage里的状态信息
    if (sessionStorage.getItem("store")) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem("store"))
        )
      );
      sessionStorage.removeItem("store");
    }

    //在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("store", JSON.stringify(this.$store.state));
    });
  },
  methods: {


    logout() {
      
      //this.session_destroy();
      this.$cookies.remove('PhpCas_SESSID');
      this.$cookies.remove('PHPSESSID');
      this.$store.commit("update", ["userName", '']);
      window.location.href = "http://localhost/restful_cas/cas_login.php?logout=";
      

    },

  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
